import * as React from "react";
import VirtualizedSelect from "react-virtualized-select";
import { CSVLink } from "react-csv";
import ICsvData from "../models/ICsvData";
import CsvValidation from "../models/CsvValidation";
import downloadIcon from "../../images/download.svg";
import * as CsvHelper from "../utils/CsvHelpers";
import IBullData from "../models/IBullData";

function funcOptionRenderer(value: any) {
  const classNames = ["bullCodeOption"];
  if (value.option === value.focusedOption) {
    classNames.push("bullCodeFocused");
  }
  if (value.valueArray.indexOf(value.option) >= 0) {
    classNames.push("bullCodeOptionSelected");
  }
  return (
    <div
      className={classNames.join(" ")}
      key={value.key}
      onClick={() => value.selectValue(value.option)}
      onMouseEnter={() => value.focusOption(value.option)}
      style={value.style}
      role="presentation"
    >
      <label className="bullCodeLabel" htmlFor="BullCodeSelector">
        {value.option.ABCode} {value.option.BullName}
      </label>
    </div>
  );
}

interface IProps {
  csvData: ICsvData[];
  isValid: CsvValidation;
  inbreedingCalcs: any[];
  bullOptions: IBullData[];
  fetchBullOptions: () => void;
  fetchCalculatedTableRows: (
    csvData: ICsvData[],
    selectedBulls: IBullData[]
  ) => void;
}

interface IState {
  clearable: boolean;
  disabled: boolean;
  multi: boolean;
  searchable: boolean;
  selectedBullCodes?: object;
}

class BullCodeSelector extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      clearable: true,
      disabled: false,
      multi: true,
      searchable: true,
      selectedBullCodes: undefined,
    };
    props.fetchBullOptions();
  }

  public onBullChange = (newValue: any) => {
    const { csvData, fetchCalculatedTableRows } = this.props;
    this.setState({ selectedBullCodes: newValue });
    fetchCalculatedTableRows(csvData, newValue);
  };

  public render() {
    const placeholder = "Enter the bull codes and hit enter";
    const { isValid, bullOptions, inbreedingCalcs } = this.props;
    const {
      clearable,
      disabled,
      multi,
      searchable,
      selectedBullCodes,
    } = this.state;

    if (inbreedingCalcs === undefined) {
      return;
    }
    let keys: string[] = [];

    if (inbreedingCalcs.length > 0) {
      const bullCodes = Object.keys(inbreedingCalcs[0]).filter(
        (bullCode) =>
          bullCode !== "Cow number/ name" &&
          bullCode !== "Cow Sire" &&
          bullCode !== "Maternal Grandsire" &&
          bullCode !== "Issues" &&
          bullCode !== ""
      );
      // re-order the internal object from inbreeding calculator to keep Issues as first column,
      // followed by cow, sire and grandsire
      keys = [
        "Issues",
        "Cow number/ name",
        "Cow Sire",
        "Maternal Grandsire",
      ].concat(bullCodes);
    }
    // not render bull code selector if invalid csv file
    /* eslint-disable consistent-return */
    if (isValid !== CsvValidation.Valid) {
      return null;
    }
    return (
      <div className="bull-selector container">
        <label htmlFor="bullPickerInput">
          {"Enter bull team using LIC bull codes"}
        </label>
        <div className="bull-selector-flexbox">
          <div className="bull-selector-flex-select">
            <VirtualizedSelect
              autofocus
              clearable={clearable}
              disabled={disabled}
              multi={multi}
              searchable={searchable}
              options={bullOptions}
              id="bullPickerInput"
              onChange={this.onBullChange}
              optionRenderer={funcOptionRenderer}
              value={selectedBullCodes}
              placeholder={placeholder}
              valueKey="BullName"
              labelKey="ABCode"
              optionHeight={30}
            />
          </div>
          <CSVLink
            className="csv-download"
            data={CsvHelper.inbreedingToCsv(inbreedingCalcs, keys)}
            filename="Inbreeding Coefficients.csv"
          >
            <img src={downloadIcon} alt="" height={20} width={20} />
            {" Download inbreeding report"}
          </CSVLink>
        </div>
      </div>
    );
  }
}

export default BullCodeSelector;



// WEBPACK FOOTER //
// ./src/scripts/components/BullCodeSelector.tsx